module.exports = __webpack_public_path__ + "static/media/static.a4a27fd3.jpg";